// Configuration pour le SPA pour savoir qu'elle url de base utilise pour appeler le backend
// Cela permet de se passer de l'ancien cookie config pour cette partie
// -----------------------------------------
// --------------- PROD ------------------
// -----------------------------------------

import { isSimulateurOriginalSource } from '../utils';

// PROD - ACCESWEB
export const ACCESWEB_PROD = 'https://accweb.mouv.desjardins.com';
export const ACCESWEB_NONPROD =
    'https://accweb-01-20494.mouvdev.desjardins.com';

// PROD - PISE AZURE EXTERNE
export const apiURLProdPise =
    'https://accesdc.mouv.desjardins.com/api/distribution-libreservice/financement/habitation/post-achat/service-renouvellement/v2/pise/api';
// -----------------------------------------
// --------------- NON PROD ------------------
// -----------------------------------------
// NonPROD - Localhost HTTP
export const apiURLNonProdLocalUnsecured =
    'http://localhost.dev.desjardins.com:8083/pise/api';
// NonPROD - PISE AZURE EXTERNE
export const apiURLNonProdPise =
    'https://accesdc.mouvdev.desjardins.com/api/distribution-libreservice/financement/habitation/post-achat/service-renouvellement/v2/pise/api';

// NonPROD - Localhost HTTPS
// NonPROD - Space DEV
export const apiURLNonProdDev =
    'https://renouvellement-bff-dev-parcours-habitation.apps.cfzcea.dev.desjardins.com/pise/api';
// NonPROD - Space QA
export const apiURLNonProdQA =
    'https://renouvellement-bff-qa-parcours-habitation.apps.cfzcea.dev.desjardins.com/pise/api';
// NonPROD - Space HA
export const apiURLNonProdHA =
    'https://renouvellement-bff-ha-parcours-habitation.apps.cfzcea.dev.desjardins.com/pise/api';
// NonPROD - Space PREPROD
export const apiURLNonProdPreProd =
    'https://renouvellement-bff-preprod-parcours-habitation.apps.cfzcea.dev.desjardins.com/pise/api';

//Accesdc-gateway NonProd
const URL_ACCESDCGATEWAY_NONPROD = 'accesdc.mouvdev.desjardins.com';

// Type d'environnement
export enum EnvType {
    LOCAL = 'LOCAL',
    DEV = 'DEV',
    QA = 'QA',
    HA = 'HA',
    PREPROD = 'PREPROD',
    NONPROD_GATEWAY = 'NONPROD_GATEWAY',
    PROD = 'PROD'
}

export type EnvConfig = {
    type: EnvType;
    usePise: boolean;
    isProd: boolean;
    baseApiUrl: string;
    accesWebUrl: string;
    // Not required in prod. Default in NonProd: HA
    envSoa?: string;
};

export function getBaseLocationUrl(): string {
    return location.protocol + '//' + location.host;
}

export function getEnvConfig(): EnvConfig {
    const url = window.location.href;
    const envConfig: EnvConfig = {
        type: EnvType.PROD,
        usePise: true,
        isProd: true,
        accesWebUrl: ACCESWEB_PROD,
        baseApiUrl: apiURLProdPise
    };

    // PROD ENV
    if (
        url.includes('.mouv.desjardins.com') ||
        url.includes('.apps.cfzcec.desjardins.com') ||
        url.includes('.apps.cfzccc.desjardins.com')
    ) {
        return envConfig;
    }

    // NON PROD ENVs
    const usePise = !isSimulateurOriginalSource();
    envConfig.accesWebUrl = ACCESWEB_NONPROD;
    envConfig.usePise = usePise;
    envConfig.isProd = false;
    const baseUrlNonProdDev = usePise ? apiURLNonProdPise : apiURLNonProdDev;

    // Localhost
    if (url.includes('localhost.dev.desjardins.com')) {
        // Localhost - Localhost URL -> Localhost config
        // Example: https://localhost.dev.desjardins.com:3000 (pointe vers API DEV)
        // Example: http://localhost.dev.desjardins.com:3000 (pointe vers API sur mon poste)
        envConfig.type = EnvType.LOCAL;
        envConfig.baseApiUrl = url.startsWith('https:')
            ? baseUrlNonProdDev
            : apiURLNonProdLocalUnsecured;
        envConfig.envSoa = 'dev';
        return envConfig;
    }

    // Pise first - Same for all NonProd
    if (usePise) {
        envConfig.baseApiUrl = apiURLNonProdPise;
    }

    if (isEnvAccesDCGatewayNonProd()) {
        // NonProd - AccesdcGateway - Space HA
        envConfig.type = EnvType.NONPROD_GATEWAY;
        envConfig.baseApiUrl = apiURLNonProdPise;
        if (isEnv('dev')) {
            // NonProd - Space DEV
            envConfig.envSoa = 'dev';
        } else if (isEnv('qa')) {
            // NonProd - Space QA
            envConfig.envSoa = 'qa';
        }
    } else {
        if (isEnv('dev')) {
            // NonProd - Space DEV
            envConfig.type = EnvType.DEV;
            envConfig.envSoa = 'dev';
            if (!usePise) {
                envConfig.baseApiUrl = apiURLNonProdDev;
            }
        } else if (isEnv('qa')) {
            // NonProd - Space QA
            envConfig.type = EnvType.QA;
            envConfig.envSoa = 'qa';
            if (!usePise) {
                envConfig.baseApiUrl = apiURLNonProdQA;
            }
        } else if (isEnv('ha')) {
            // NonProd - Space HA
            envConfig.type = EnvType.HA;
            if (!usePise) {
                envConfig.baseApiUrl = apiURLNonProdHA;
            }
        } else {
            // NonProd - Space PREPROD
            envConfig.type = EnvType.PREPROD;
            envConfig.envSoa = 'preprod';
            if (!usePise) {
                envConfig.baseApiUrl = apiURLNonProdPreProd;
            }
        }
    }
    return envConfig;
}

const isEnv = (env: string): boolean => {
    const url = window.location.href;
    const URL_APP = 'renouvellement-bff-';

    return (
        url.includes(URL_ACCESDCGATEWAY_NONPROD + `/${env}/`) ||
        url.includes(URL_APP + env)
    );
};

export const useFakeToken = (): boolean => {
    //Si c'est la prod -> on n'utilise pas de fake token
    if (!isEnvNonProd()) {
        return false;
    }
    //Si c'est l'accesdc-gateway nonprod -> on n'utilise pas de fake token
    if (isEnvAccesDCGatewayNonProd()) {
        return false;
    }
    return true;
};

// Fastest way to know if we are in NonProd
export const isEnvNonProd = (): boolean => {
    const url = window.location.href;
    return (
        url.includes('.mouvdev.desjardins.com') ||
        url.includes('.dev.desjardins.com')
    );
};

// Fastest way to know if we are with accesdc-gateway nonprod
export const isEnvAccesDCGatewayNonProd = (): boolean => {
    return window.location.href.includes(URL_ACCESDCGATEWAY_NONPROD);
};
